export default "__VITE_ASSET__CgGX7qn3__"